import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { consentGuard } from './core/auth/consent.guard';

export const routes: Routes = [
  // --- Auth (public) ---
  {
    path: 'login',
    loadChildren: () =>
      import('./features/login/login.routes').then((m) => m.LOGIN_ROUTES),
  },

  // --- Onboarding (first login only) ---
  {
    path: 'onboarding',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/onboarding/onboarding-slides.component').then(
        (m) => m.OnboardingSlidesComponent,
      ),
  },

  // --- Protected routes (require auth + consent) ---
  {
    path: '',
    canActivate: [authGuard, consentGuard],
    children: [
      // --- Tab navigation (Mis OT, Historial, Perfil) ---
      {
        path: '',
        loadComponent: () =>
          import('./shared/layout/tabs.page').then((m) => m.TabsPage),
        children: [
          { path: '', redirectTo: 'orders', pathMatch: 'full' },
          {
            path: 'orders',
            loadChildren: () =>
              import('./features/my-orders/my-orders.routes').then(
                (m) => m.MY_ORDERS_ROUTES,
              ),
          },
          {
            path: 'history',
            loadChildren: () =>
              import('./features/history/history.routes').then(
                (m) => m.HISTORY_ROUTES,
              ),
          },
          {
            path: 'profile',
            loadChildren: () =>
              import('./features/profile/profile.routes').then(
                (m) => m.PROFILE_ROUTES,
              ),
          },
          {
            path: 'inventory',
            loadChildren: () =>
              import('./features/inventory/inventory.routes').then(
                (m) => m.INVENTORY_ROUTES,
              ),
          },
        ],
      },

      // --- Non-tab routes (full screen, stack nav) ---
      {
        path: 'notifications',
        loadComponent: () =>
          import('./features/notifications/notifications.page').then(
            (m) => m.NotificationsPage,
          ),
      },
      {
        path: 'orders/:id',
        loadChildren: () =>
          import('./features/order-detail/order-detail.routes').then(
            (m) => m.ORDER_DETAIL_ROUTES,
          ),
      },
      {
        path: 'orders/:id/execute',
        loadChildren: () =>
          import('./features/execution/execution.routes').then(
            (m) => m.EXECUTION_ROUTES,
          ),
      },
      {
        path: 'orders/:id/evidence',
        loadChildren: () =>
          import('./features/evidence/evidence.routes').then(
            (m) => m.EVIDENCE_ROUTES,
          ),
      },
      {
        path: 'orders/:id/complete',
        loadChildren: () =>
          import('./features/complete/complete.routes').then(
            (m) => m.COMPLETE_ROUTES,
          ),
      },
      {
        path: 'orders/:id/settlement/create',
        loadComponent: () =>
          import('./features/settlement/settlement-form.page').then(
            (m) => m.SettlementFormPage,
          ),
      },
      {
        // Autocreación de OT por el técnico (spec technician-self-created-work-order).
        path: 'create-order',
        loadComponent: () =>
          import('./features/create-order/create-order.page').then(
            (m) => m.CreateOrderPage,
          ),
      },
      {
        path: 'sync',
        loadChildren: () =>
          import('./features/sync/sync.routes').then(
            (m) => m.SYNC_ROUTES,
          ),
      },
      {
        path: 'orders/:id/register-asset',
        loadChildren: () =>
          import('./features/asset-registration/asset-registration.routes').then(
            (m) => m.ASSET_REGISTRATION_ROUTES,
          ),
      },
    ],
  },

  // --- Fallback ---
  { path: '**', redirectTo: 'orders' },
];
